import { Type, type Static } from '@sinclair/typebox';
import { FIELD_LIMITS, NUMERIC_LIMITS } from '../constants.js';
import { IsoDateSchema, RowVersionField, SoftDeleteFields, TimestampFields, UuidSchema } from './common.js';

export const DeliveryEventSchema = Type.Object({
  id: UuidSchema,
  projectItemId: UuidSchema,
  quantity: Type.Integer({ minimum: 1, maximum: NUMERIC_LIMITS.QUANTITY_MAX }),
  deliveryDate: IsoDateSchema,
  referenceNumber: Type.Union([Type.String({ maxLength: FIELD_LIMITS.REFERENCE_NUMBER_MAX }), Type.Null()]),
  remarks: Type.Union([Type.String({ maxLength: FIELD_LIMITS.NOTES_MAX }), Type.Null()]),
  recordedByUserId: UuidSchema,
  ...TimestampFields,
  ...SoftDeleteFields,
  ...RowVersionField,
});
export type DeliveryEvent = Static<typeof DeliveryEventSchema>;

export const DeliveryEventCreateSchema = Type.Object({
  quantity: Type.Integer({ minimum: 1, maximum: NUMERIC_LIMITS.QUANTITY_MAX }),
  deliveryDate: IsoDateSchema,
  referenceNumber: Type.Optional(Type.Union([Type.String({ maxLength: FIELD_LIMITS.REFERENCE_NUMBER_MAX }), Type.Null()])),
  remarks: Type.Optional(Type.Union([Type.String({ maxLength: FIELD_LIMITS.NOTES_MAX }), Type.Null()])),
});
export type DeliveryEventCreate = Static<typeof DeliveryEventCreateSchema>;
